import React, { useCallback, useEffect, useState } from "react";
import Stepper from "../../components/Stepper";
import {
  useNavigate,
  useLocation,
  useSearchParams,
  useParams,
} from "react-router-dom";
import {
  IconArrowNarrowLeftDashed,
  IconArrowNarrowRightDashed,
} from "@tabler/icons-react";
import { useForm, FormProvider, useFormContext } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { isValidPhoneNumber } from "react-phone-number-input";
import usePostRequest from "../../hooks/usePostRequest";
import { API_ENDPOINTS } from "../../constant/_constant";
import { toast } from "react-toastify";
import {
  Button,
  Card,
  Form,
  Alert,
  Spinner,
  InputGroup,
  DropdownDivider,
  Row,
  Col,
} from "react-bootstrap";
import Notes from "../../components/Notes/Notes";
import Attachment from "../RFQ/Attachment";
import ComanConfirmationModal from "../../components/ComanConfirmationModal";
import SuccsessMsgModal from "../../components/SuccessMsgModal";
import { transformData } from "../../utils/_helpers";
import FileUpload from "../../components/Attachment/Attachment";
import BugForm from "./BugForm";
import useIdleLogout from "../../hooks/useIdleLogout";

const generateUniqueId = () => {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  let result = "";
  for (let i = 0; i < 8; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    result += characters.charAt(randomIndex);
  }

  const timestamp = Date.now().toString();
  const uniqueId = result + timestamp.slice(-4);
  return uniqueId;
};

const validationSchema = Yup.object().shape({
  bug_title: Yup.string().required("Bug title is required"),
  priority_type: Yup.string().required("Bug priority is required"),
  description: Yup.string().required("Bug description is required"),
  stepsReproduce: Yup.string()
    .transform((value) => (value === "" ? null : value))
    .nullable()
    .optional(),
  expectedBehaviour: Yup.string()
    .transform((value) => (value === "" ? null : value))
    .nullable()
    .optional(),
  actualBehaviour: Yup.string()
    .transform((value) => (value === "" ? null : value))
    .nullable()
    .optional(),
  browserDetails: Yup.string()
    .transform((value) => (value === "" ? null : value))
    .nullable()
    .optional(),
});

function ReportBugs() {
  const PORT = process.env.REACT_APP_BASE_URL;
  const { auto_id } = useParams();
  const navigate = useNavigate();
  const steps = ["Report", "Attachments"];
  const [currentStep, setCurrentStep] = useState(1);
  const [formId, setFormId] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [bugDataFetched, setBugDataFetched] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState({
    show: false,
    message: "",
    btntext: "",
    title: "",
  });
  const [isModalCnfirmOpen, setIsModalCnfirmOpen] = useState({
    show: false,
    action: null,
    message: "",
  });

  const methods = useForm({
    resolver: yupResolver(validationSchema),
    mode: "onChange",
  });

  const {
    handleSubmit,
    setError,
    reset,
    setValue,
    getValues,
    formState: { errors },
  } = methods;

  console.log("errors", errors);

  const { data: bugData, postData: fetchCustomer } = usePostRequest(
    API_ENDPOINTS.GET_SINGLE_CUSTOMER
  );
  const { isLoading, postData: uploadImage } = usePostRequest(
    API_ENDPOINTS.UPLOAD_ATTACHMENTS
  );

  const { isLoadingquickbook, postData: WihtouthQuickBook } = usePostRequest(
    API_ENDPOINTS.UPDATE_CUSTOMER_WITHOUT_QUICKBOOK
  );

  const { isLoading: createLoading, postData } = usePostRequest(
    API_ENDPOINTS.CREATE_BUG
  );

  //   const { isLoading: createLoadings, postDatas } = usePostRequest(
  //     API_ENDPOINTS.UPDATE_BUG
  //   );

  useIdleLogout();

  useEffect(() => {
    if (auto_id && !bugDataFetched) {
      fetchCustomer({ auto_id });
      setBugDataFetched(true);
      setIsEditing(true);
    }
  }, [auto_id, bugDataFetched, fetchCustomer]);

  const getFieldsForCurrentStep = (step) => {
    switch (step) {
      case 1:
        return ["bug_title", "priority_type", "description"];
      case 2:
        return [];
      default:
        return [];
    }
  };

  useEffect(() => {
    const newFormId = generateUniqueId();
    setFormId(newFormId);
    reset();
  }, []);

  const handleStepChange = useCallback(
    (type) => {
      if (type === "next") {
        const currentData = methods.getValues();
        console.log("currentData", currentData);
        const fieldsToValidate = getFieldsForCurrentStep(currentStep);
        methods.trigger(fieldsToValidate).then((isValid) => {
          if (isValid) {
            if (currentStep <= steps.length - 1) {
              setCurrentStep((prev) => prev + 1);
            }
          } else {
            console.log("Errors:", methods.formState.errors);
          }
        });
      } else {
        console.log("Errors:2", methods.formState.errors);
        if (currentStep > 1) {
          setCurrentStep((prev) => prev - 1);
        }
      }
    },
    [currentStep, methods]
  );

//   useEffect(() => {
//     const handleKeyDown = (event) => {
//       if (event.key === "ArrowRight") {
//         handleStepChange("next");
//       } else if (event.key === "ArrowLeft") {
//         handleStepChange("prev");
//       }
//     };

//     document.addEventListener("keydown", handleKeyDown);
//     return () => {
//       document.removeEventListener("keydown", handleKeyDown);
//     };
//   }, [handleStepChange]);

  const onError = (error) => {
    toast.error(error?.message);
  };

  const onSubmit = (data) => {
    console.log("data", data);

    const payload = {
      auto_id: auto_id,
      attachment_id: formId,
      title: data.bug_title || null,
      priority: data.priority_type,
      description: data.description || null,
      steps_reproduce: data.stepsReproduce || null,
      expected_behavior: data.expectedBehaviour || null,
      actual_behavior: data.actualBehaviour || null,
      browser_details: data.browserDetails || null,
    };

    const formData = new FormData();

    if (data?.files && data?.files.length > 0) {
      data.files.forEach((file, index) => {
        formData.append("customer", file);
      });
    }

    // console.log(payload, "payload");
    const onSuccess = (res) => {
      // createNotes(notesPayload);
      formData.append("auto_id", res?.auto_id);
      if (data?.files && data?.files.length > 0) {
        uploadImage(formData, API_ENDPOINTS.UPLOAD_ATTACHMENTS);
      }
      // UPLOAD_ATTACHMENTS
      setIsModalOpen({
        show: true,
        message: res.message,
        btntext: "Close",
        title: res.message,
      });
    };
    if (bugData && bugData?.data?.quickbook_id == 0) {
      WihtouthQuickBook(JSON.stringify(payload), onSuccess, onError);
    } else {
      postData(JSON.stringify(payload), onSuccess, onError);
    }
  };

  return (
    <>
      <ComanConfirmationModal
        show={isModalCnfirmOpen.show}
        onHide={() => setIsModalCnfirmOpen({ ...isModalOpen, show: false })}
        title={isModalCnfirmOpen.title}
        message={isModalCnfirmOpen.message}
        onConfirm={isModalCnfirmOpen.onConfirm}
        icon={isModalCnfirmOpen.icon}
        type={isModalCnfirmOpen.type}
      />

      <SuccsessMsgModal
        show={isModalOpen.show}
        onHide={() => {
          setIsModalOpen({ ...isModalOpen, show: false });
          navigate("/");
        }}
        title={isModalOpen.title}
        btntext={isModalOpen.btntext}
        message={isModalOpen.message}
      />

      <Row className="justify-content-md-center">
        <Col xs={8}>
          <Card className="bug_card_box">
            <Card.Body>
              <FormProvider
                {...methods}
                className=""
                onSubmit={methods.handleSubmit(onSubmit)}
              >
                <Form onSubmit={methods.handleSubmit(onSubmit)}>
                  {currentStep === 1 && <BugForm attachmnetid={formId} />}
                  {/* {currentStep === 2 && (
                <FileUpload moduleType={"BUG"} attachmnetid={formId} />
              )} */}

                  <div className="d-flex justify-content-center gap-3 mt-3">
                    {auto_id
                      ? currentStep < steps.length && (
                          <div className="d-flex">
                            <Button variant="warning" type="submit">
                              {createLoading ? (
                                <Spinner
                                  as="span"
                                  animation="border"
                                  size="sm"
                                  role="status"
                                  aria-hidden="true"
                                />
                              ) : (
                                "Update"
                              )}
                            </Button>
                          </div>
                        )
                      : null}

                    {currentStep === 1 && (
                      <div className="d-flex">
                        <Button variant="warning" type="submit">
                          {createLoading ? (
                            <Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />
                          ) : (
                            "Submit Bug Report"
                          )}
                        </Button>
                      </div>
                    )}
                  </div>
                </Form>
              </FormProvider>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
}

export default ReportBugs;
